module.exports = __webpack_public_path__ + "static/tickethoss_orange-406b7f86f008813802d035c0e1c76138.svg";